var VectorLayer = require("./VectorLayer"),
    ol = require("openlayers"),
    _ = require("underscore"),
    $ = require("jquery"),
    utils = require("Utils"),
    Visualization = require("../Project/Visualization");

var devPixelRatio = 1 / utils.getDevicePixelRatio();

var OmsCategoryLayer = VectorLayer.extend({

    initialize: function(options){
        var that = this;

        // Vector layer can work with only one project layer
        that._takeOnePrjLayer(options);

        OmsCategoryLayer.__super__.initialize.call(that, options);

        that._olLayer = new ol.layer.Group({
            visible: options.visible
        });
        that._olLayer.set('omjsLayer', that);

        that._setup(options);
    },

    _takeOnePrjLayer: function(options) {
        var that = this;
        if ('projectLayers' in options) {
            if (_.isArray(options['projectLayers'])) {
                that._prjLayer = options['projectLayers'][0];
            } else if ('getArray' in options['projectLayers']) {
                that._prjLayer = options['projectLayers'].at(0);
            }
        }
    },

    onAdd: function(view){
        var that = this;
        that.view = view;
        that.map = view.getMap();
        that.map.getView().on('change:resolution', function(){
            that.switchLayerSources();
        });
    },

    _setup: function(options){
        var that = this,
            vStyle,
            startResolution = 156543.03392804097,
            clusterSizeOptionsOverride;

        options || (options = {});

        if('projectLayers' in options){
            that._takeOnePrjLayer(options);
            that._prjLayers = options.projectLayers;
        }

        if (!that._prjLayer) {
            return that;
        }

        if (!(that._prjLayer instanceof Visualization) || that._prjLayer.get('render_type') != 1) {
            throw new Error("Project vector visualization required!!!");
        }

        clusterSizeOptionsOverride = that._prjLayer.options.clusterSize || {};
        that.cluserSizeOptions = {
            // см комментарии по использованию в OmsVectorLayer.js
            width       : 20,
            height      : 17,
            figures     : [
                {
                    width       : 18,
                    height      : 15,
                    type        : 'rect',
                    radius      : 2,
                    strokeStyle : '#7fa3c6',
                    fillStyle   : '#fff',
                    lineWidth   : 1
                }
            ],
            fontSize    : 20,
            fontFamily  : 'Arial',
            textAlign   : 'center',
            textBaseline: 'middle',
            textColor   : '#000'
        };
        $.extend(
            that.cluserSizeOptions,
            clusterSizeOptionsOverride,
            that.view.options.misc_data.objects_counter_style
        );

        that.project = that._prjLayer.options.project;

        if (that._prjLayer.get('vectorSettings')['clusteringEnabled']) {
            that.options['clustering'] = that._prjLayer.get('vectorSettings')['clusterSettings'].radius;
        }

        vStyle = that._prjLayer.get('vectorSettings');
        that._createGroupStruct();

        that.switchLayerSources();

        if (vStyle['zoomsEnabled']) {
            that._olLayer.setMinResolution(startResolution / Math.pow(2, vStyle.maxZoom));
            that._olLayer.setMaxResolution(startResolution / Math.pow(2, vStyle.minZoom)+0.5);
        } else {
            that._olLayer.setMinResolution(startResolution / Math.pow(2, 22));
            that._olLayer.setMaxResolution(startResolution+0.5);
        }

        if (that._prjLayer.get('vectorSettings').clusterSettings.splitByCategories) {
            that.setGroupStyle();
        } else {
            that.setLayerStyle();
        }

        return that;
    },


    updateLayer: function() {
        var that = this,
            sources = {},
            // для оптимизации аккумулируем фичи и разом добавим в сорсы
            sourcesFeatures = {},
            features = [],
            // фичи без разделения по категориям
            commonFeatures = [],
            columnCode = that._prjLayer.get('visualSettings')['columnCode'],
            featureClass,
            cValue,
            options = {};


        that._prjLayer.project.loadStructure(that._prjLayer.get('code')).then(function (str) {
            var fields = [];
            $.each(str, function(id, el) {
                fields.push(el.code);
            });
            $.extend(options, that.options);
            options.fields = options.fields.concat(fields);
            return that._prjLayer.loadObjects(options);
        }).then(function () {

            that._olLayer.getLayers().forEach(function(sLayer){
                sources[sLayer.categoryValue] = sLayer.vSource;
                sourcesFeatures[sLayer.categoryValue] = [];
                sLayer.vSource.clear();
            });
            that._olLayer.vSource.clear();

            that._prjLayer.objects.each(function(obj, i){
                var geom = obj.getGeometry();

                if(geom && geom.type in ol.geom){
                    obj.feature = new ol.Feature({
                        obj     : obj,
                        geometry: new ol.geom[geom.type](geom.coordinates)
                    });
                    obj.feature.setId(obj.id);
                    features.push(obj.feature);

                    if (columnCode == 'orbis_id') {
                        cValue = obj.getId();
                    } else {
                        cValue = obj.get(columnCode);
                    }

                    if(that._prjLayer.get('vectorSettings').clusterSettings.splitByCategories) {
                        if (cValue in sourcesFeatures) {
                            sourcesFeatures[cValue].push(obj.feature);
                        } else if ('default' in sourcesFeatures) {
                            sourcesFeatures['default'].push(obj.feature);
                        }
                    } else {
                        featureClass = that.getVisClassByValue(cValue);
                        if (featureClass && featureClass.checked) {
                            commonFeatures.push(obj.feature)
                        }
                    }
                }
            });
            if(that._prjLayer.get('vectorSettings').clusterSettings.splitByCategories) {
                for (cValue in sourcesFeatures) {
                    if (sourcesFeatures.hasOwnProperty(cValue)) {
                        sources[cValue].addFeatures(sourcesFeatures[cValue]);
                    }
                }
            } else if (commonFeatures.length) {
                that._olLayer.getLayers().getArray()[0].vSource.addFeatures(commonFeatures);
            }
            that._olLayer.vSource.addFeatures(features);
        });
    },

    _createGroupStruct: function(){
        var that = this,
            classes,
            columnCode,
            subLayer,
            i,
            sources = {},
            features = [],
            cValue,
            featureClass,
            cStyle = that._prjLayer.get('vectorSettings').clusterSettings,
            clusteringEnabled = that._prjLayer.get('vectorSettings').clusteringEnabled;

        classes = that._prjLayer.get('visualSettings')['classesSettings']['classes'];
        columnCode = that._prjLayer.get('visualSettings')['columnCode'];
        that.categoryColumnCode = columnCode;

        that._olLayer.getLayers().clear();
        if (that._olLayer.vSource) {
            that._olLayer.vSource.clear();
        } else {
            that._olLayer.vSource = new ol.source.Vector();
        }
        if (cStyle.splitByCategories) {
            for (i in classes) {
                subLayer = new ol.layer.Vector();
                subLayer.set('omjsLayer', that);
                subLayer.styleCache = {};
                sources[classes[i].value] = new ol.source.Vector();
                subLayer.vSource = sources[classes[i].value];
                if (clusteringEnabled) {
                    subLayer.vClusterSource = new ol.source.Cluster({
                        source: subLayer.vSource,
                        distance: cStyle.radius
                    });
                } else {
                    subLayer.vClusterSource = null;
                }
                subLayer.categoryValue = classes[i].value;
                that._olLayer.getLayers().push(subLayer);
                subLayer.setVisible(classes[i]['checked']);
            }

            if (that._prjLayer.get('visualSettings')['classesSettings']['defaultClass']) {
                subLayer = new ol.layer.Vector();
                subLayer.set('omjsLayer', that);
                subLayer.styleCache = {};
                sources['default'] = new ol.source.Vector();
                subLayer.vSource = sources['default'];
                if (clusteringEnabled) {
                    subLayer.vClusterSource = new ol.source.Cluster({
                        source: subLayer.vSource,
                        distance: cStyle.radius
                    });
                } else {
                    subLayer.vClusterSource = null;
                }
                subLayer.categoryValue = that._prjLayer.get('visualSettings')['classesSettings']['defaultClass'].value;
                that._olLayer.getLayers().push(subLayer);
                subLayer.setVisible(that._prjLayer.get('visualSettings')['classesSettings']['defaultClass'].checked);
            }

        } else {
            subLayer = new ol.layer.Vector();
            subLayer.set('omjsLayer', that);
            subLayer.styleCache = {};
            subLayer.vSource = new ol.source.Vector();
            if (clusteringEnabled) {
                subLayer.vClusterSource = new ol.source.Cluster({
                    source: subLayer.vSource,
                    distance: cStyle.radius
                });
            } else {
                subLayer.vClusterSource = null;
            }
            that._olLayer.getLayers().push(subLayer);
        }

        // делаем кучу фич и распихиваем их в зависимости от структуры
        that._prjLayer.objects.each(function(obj, i){
            var geom = obj.getGeometry();

            if(geom && geom.type in ol.geom){
                obj.feature = new ol.Feature({
                    obj     : obj,
                    geometry: new ol.geom[geom.type](geom.coordinates)
                });
                obj.feature.setId(obj.id);
                features.push(obj.feature);

                if (columnCode == 'orbis_id') {
                    cValue = obj.getId();
                } else {
                    cValue = obj.get(columnCode);
                }

                if(that._prjLayer.get('vectorSettings').clusterSettings.splitByCategories) {
                    if (cValue in sources) {
                        sources[cValue].addFeature(obj.feature);
                    } else if ('default' in sources) {
                        sources['default'].addFeature(obj.feature);
                    }
                } else {
                    featureClass = that.getVisClassByValue(cValue);
                    if (featureClass && featureClass.checked) {
                        subLayer.vSource.addFeature(obj.feature);
                    }
                }
            }
        });
        that._olLayer.vSource.addFeatures(features);
    },

    fillSources: function(objects){
        var that = this,
            sources = {},
            obj,
            i,
            columnCode = that._prjLayer.get('visualSettings')['columnCode'],
            cValue,
            featureClass;

        that._olLayer.getLayers().forEach(function(subLayer){
            sources[subLayer.categoryValue] = subLayer.vSource;
            subLayer.vSource.clear();
        });

        for (i in objects) {
            obj = objects[i];

            if (columnCode == 'orbis_id') {
                cValue = obj.getId();
            } else {
                cValue = obj.get(columnCode);
            }

            if(that._prjLayer.get('vectorSettings').clusterSettings.splitByCategories) {
                if (cValue in sources) {
                    sources[cValue].addFeature(obj.feature);
                } else if ('default' in sources) {
                    sources['default'].addFeature(obj.feature);
                }
            } else {
                featureClass = that.getVisClassByValue(cValue);
                if (featureClass && featureClass.checked) {
                    subLayer.vSource.addFeature(obj.feature);
                }
            }
        }
    },

    switchLayerSources: function(){
        var that = this,
            zoom,
            cStyle = that._prjLayer.get('vectorSettings').clusterSettings;

        if (that._olLayer.getLayers().getLength() == 0 || !that.map) {
            return;
        }

        zoom = that.map.getView().getZoom();

        if (that._prjLayer.get('vectorSettings').clusteringEnabled) {
            if (cStyle.maxZoomEnabled && zoom > cStyle.maxZoom) {
                that._olLayer.getLayers().forEach(function (subLayer) {
                    subLayer.setSource(subLayer.vSource);
                });
            } else {
                that._olLayer.getLayers().forEach(function (subLayer) {
                    subLayer.setSource(subLayer.vClusterSource);
                });
            }
        } else {
            that._olLayer.getLayers().forEach(function (subLayer) {
                subLayer.setSource(subLayer.vSource);
            });
        }
    },

    _createImgLoader: function(iconUrl) {
        var that = this;

        that.imgCache[iconUrl] = new Image();
        that.imgCache[iconUrl].def = $.Deferred();
        that.imgCache[iconUrl].crossOrigin = 'anonymous';
        that.imgCache[iconUrl].onload = function(){
            this.def.resolve(true);
        };
        return that.imgCache[iconUrl].def;
    },

    _reloadLayerIcons: function(){
        var that = this,
            master = $.Deferred(),
            defs = [],
            vStyle,
            classes,
            defClass,
            i,
            url;

        that.imgCache = {};


        classes = that._prjLayer.get('visualSettings')['classesSettings'].classes;
        defClass = that._prjLayer.get('visualSettings')['classesSettings'].defaultClass;
        vStyle = that._prjLayer.get('vectorSettings');

        for (var c in classes) {
            if (classes[c].icon && classes[c].icon != "" && classes[c].icon != null && that.imgCache[classes[c].icon] === undefined) {
                defs.push(that._createImgLoader(classes[c].icon));
            }
        }

        if (vStyle['clusteringEnabled'] && vStyle['clusterSettings'].icon != null && vStyle.clusterSettings.iconEnabled
            && that.imgCache[vStyle.clusterSettings.icon] === undefined) {
            defs.push(that._createImgLoader(vStyle.clusterSettings.icon));
        }

        if (defClass != null && defClass.icon) {
            defs.push(that._createImgLoader(defClass.icon));
        }

        if (_.isEmpty(that.imgCache)) {
            master.resolve(true);
            return master;
        }

        $.when.apply($,defs).then(function(){
            master.resolve(true);
        });

        for (i in that.imgCache) {
            url = that.project.apiUrlLocation.protocol
                + '//'
                + that.project.apiUrlLocation.hostname
                + i + '?r=' + Math.floor(Math.random() * (999999)) + 1;

            that.imgCache[i].src = url;
        }
        return master;
    },

    getVisClassByValue: function(value){
        var that = this,
            visualSettings = that._prjLayer.get('visualSettings');

        for(var i in visualSettings.classesSettings.classes){
            if(visualSettings.classesSettings.classes[i].value == value){
                return visualSettings.classesSettings.classes[i]
            }
        }

        return visualSettings.classesSettings.defaultClass
    },

    setGroupStyle: function(){
        var that = this,
            vStyle = that._prjLayer.get('vectorSettings'),
            layerGrp = that._olLayer,
            iconImg;

        that._reloadLayerIcons().done(function(){

            layerGrp.getLayers().forEach(function(subLayer){
                subLayer.styleCache = {};

                var categoryClass = that.getVisClassByValue(subLayer.categoryValue);
                subLayer.categoryIcon = categoryClass.icon;
                subLayer.setStyle(function(feature, resolution){
                    var size = feature.get('features') ? feature.get('features').length : 1,
                        styles = [],
                        scale,
                        offset = vStyle.stylesPoint.iconOffsetEnabled
                            ? [-vStyle.stylesPoint.iconDx, -vStyle.stylesPoint.iconDy]
                            : [0,0];
                    if (resolution+'' in subLayer.styleCache) {
                        if (subLayer.styleCache[resolution+''][size]) {
                            return subLayer.styleCache[resolution+''][size];
                        }
                    } else {
                        subLayer.styleCache[resolution+''] = [];
                    }

                    if (size > 1) {

                        var min = 2, max = 2;
                        subLayer.getSource().getFeatures().forEach(function(f){
                            min = Math.min(min, f.get('features').length);
                            max = Math.max(max, f.get('features').length);
                        });

                        var sizeDelta = vStyle.clusterSettings.iconSizeMax - vStyle.clusterSettings.iconSizeMin;
                        var iconSize = parseInt(vStyle.clusterSettings.iconSizeMin + sizeDelta * (size-min)/(max-min));

                        if (vStyle.clusterSettings.icon != null && vStyle.clusterSettings.iconEnabled) {
                            iconImg = that.imgCache[vStyle.clusterSettings.icon];
                            offset = vStyle.clusterSettings.iconOffsetEnabled
                                ? [-vStyle.clusterSettings.iconDx, -vStyle.clusterSettings.iconDy]
                                : [0,0];
                        } else {
                            iconImg = that.imgCache[subLayer.categoryIcon];
                            offset = vStyle.stylesPoint.iconOffsetEnabled
                                ? [-vStyle.stylesPoint.iconDx, -vStyle.stylesPoint.iconDy]
                                : [0,0];
                        }

                        offset[0] += iconImg.width/2;
                        offset[1] += iconImg.height/2;

                        scale =  vStyle.clusterSettings.iconSizeEnabled ? iconSize/iconImg.width : 1;

                        styles.push(new ol.style.Style({
                            image: new ol.style.Icon({
                                anchor: offset,
                                anchorXUnits: 'pixels',
                                anchorYUnits: 'pixels',
                                opacity: 1,
                                img: iconImg,
                                imgSize:[iconImg.width,iconImg.height],
                                scale: scale
                            })
                        }));

                        // count style
                        if (vStyle.clusterSettings.showObjectsCount) {
                            try {
                                scale = 1 / (that.pixelRatio || devPixelRatio);
                                var countIcon = utils.createObjectsCountCnv(size < 100 ? size.toString() : '*', scale,
                                    that.cluserSizeOptions);
                                styles.push(new ol.style.Style({
                                    image: new ol.style.Icon({
                                        anchor: [
                                            (that.cluserSizeOptions.width / 2 - vStyle.clusterSettings.objectsCountDx) * scale,
                                            (that.cluserSizeOptions.height / 2 - vStyle.clusterSettings.objectsCountDy) * scale
                                        ],
                                        anchorXUnits: 'pixels',
                                        anchorYUnits: 'pixels',
                                        opacity: 1,
                                        imgSize: [countIcon.width, countIcon.height],
                                        img: countIcon,
                                        scale: 1 / scale
                                    })
                                }));
                            } catch (err) {
                                console.error(err);
                            }
                        }
                    } else {
                        // one feature style
                        iconImg = that.imgCache[subLayer.categoryIcon];
                        offset[0] += iconImg.width/2;
                        offset[1] += iconImg.height/2;

                        styles.push(new ol.style.Style({
                            image: new ol.style.Icon({
                                anchor: offset,
                                anchorXUnits: 'pixels',
                                anchorYUnits: 'pixels',
                                opacity: 1,
                                img: iconImg,
                                imgSize:[iconImg.width,iconImg.height]
                            })
                        }));
                    }

                    subLayer.styleCache[resolution+''][size] = styles;
                    return styles;
                });
            });
        })
    },

    setLayerStyle: function(){
        var that = this,
            iconImg,
            vStyle = that._prjLayer.get("vectorSettings"),
            cStyle = vStyle.clusterSettings;

        that._reloadLayerIcons().done(function(){
            that._olLayer.getLayers().forEach(function(subLayer){
                subLayer.styleCache = {};

                subLayer.setStyle(function(feature, resolution){
                    var size = feature.get('features') ? feature.get('features').length : 1,
                        styles = [],
                        scale,
                        category,
                        offset = vStyle.stylesPoint.iconOffsetEnabled
                            ? [-vStyle.stylesPoint.iconDx, -vStyle.stylesPoint.iconDy]
                            : [0,0],
                        cacheKey,
                        featureObj;

                    featureObj = feature.get('features')
                        ? feature.get('features')[0].get('obj')
                        : feature.get('obj');
                    // Колонка orbis_id в атрибуты объекта не записывается, она является Id объекта
                    category = that.getVisClassByValue(that.categoryColumnCode == 'orbis_id'
                        ? featureObj.getId()
                        : featureObj.get(that.categoryColumnCode)
                    );

                    if (size > 1) {
                        cacheKey = resolution+'_cluster';
                    } else {
                        cacheKey = resolution + '_' + category.value;
                    }

                    if (cacheKey in subLayer.styleCache) {
                        if (subLayer.styleCache[cacheKey][size]) {
                            return subLayer.styleCache[cacheKey][size];
                        }
                    } else {
                        subLayer.styleCache[cacheKey] = [];
                    }

                    if (size > 1) {
                        var min = 2, max = 2;
                        subLayer.getSource().getFeatures().forEach(function(f){
                            min = Math.min(min, f.get('features').length);
                            max = Math.max(max, f.get('features').length);
                        });

                        var sizeDelta = cStyle.iconSizeMax - cStyle.iconSizeMin;
                        var iconSize = parseInt(cStyle.iconSizeMin + sizeDelta * (size-min)/(max-min));

                        if (cStyle.icon != null && cStyle.iconEnabled) {
                            iconImg = that.imgCache[cStyle.icon];
                            offset = cStyle.iconOffsetEnabled
                                ? [-cStyle.iconDx, -cStyle.iconDy]
                                : [0,0];
                        } else {
                            iconImg = that.imgCache[category.icon];
                            offset = vStyle.stylesPoint.iconOffsetEnabled
                                ? [-vStyle.stylesPoint.iconDx, -vStyle.stylesPoint.iconDy]
                                : [0,0];
                        }

                        offset[0] += iconImg.width/2;
                        offset[1] += iconImg.height/2;

                        scale =  cStyle.iconSizeEnabled ? iconSize/iconImg.width : 1;

                        styles.push(new ol.style.Style({
                            image: new ol.style.Icon({
                                anchor: offset,
                                anchorXUnits: 'pixels',
                                anchorYUnits: 'pixels',
                                opacity: 1,
                                img: iconImg,
                                imgSize:[iconImg.width,iconImg.height],
                                scale: scale
                            })
                        }));

                        // count style
                        if (cStyle.showObjectsCount) {
                            try {
                                scale = 1 / (that.pixelRatio || devPixelRatio);
                                var countIcon = utils.createObjectsCountCnv(size < 100 ? size.toString() : '*', scale,
                                    that.cluserSizeOptions);
                                styles.push(new ol.style.Style({
                                    image: new ol.style.Icon({
                                        anchor: [
                                            (that.cluserSizeOptions.width / 2 - vStyle.clusterSettings.objectsCountDx) * scale,
                                            (that.cluserSizeOptions.height / 2 - vStyle.clusterSettings.objectsCountDy) * scale
                                        ],
                                        anchorXUnits: 'pixels',
                                        anchorYUnits: 'pixels',
                                        opacity: 1,
                                        imgSize: [countIcon.width, countIcon.height],
                                        img: countIcon,
                                        scale: 1 / scale
                                    })
                                }));
                            } catch (err) {
                                console.error(err);
                            }
                        }
                    } else {
                        // one feature style
                        iconImg = that.imgCache[category.icon];
                        offset[0] += iconImg.width/2;
                        offset[1] += iconImg.height/2;

                        styles.push(new ol.style.Style({
                            image: new ol.style.Icon({
                                anchor: offset,
                                anchorXUnits: 'pixels',
                                anchorYUnits: 'pixels',
                                opacity: 1,
                                img: iconImg,
                                imgSize:[iconImg.width,iconImg.height]
                            })
                        }));
                    }

                    subLayer.styleCache[cacheKey][size] = styles;
                    return styles;
                });
            });
        });
    }
});

module.exports = OmsCategoryLayer;




//////////////////
// WEBPACK FOOTER
// ./src/View/OmsCategoryLayer.js
// module id = 52
// module chunks = 0